import { useEffect, useRef } from 'react'
import { SettingsType } from '../../constants/enums'
import { USER_EXTENSIONS } from '../../mfcLogic/ueopts'
import { playAudibleAlert } from '../../mfcLogic/utilities'
import { useSettingSelector } from './useSettings'
import { useUserSelector } from './useUser'

export function useAlertWebcamViewer() {
    const participants = useUserSelector('me', 'participants')
    const [audibleAlertMyWebcamWatcherJoined] = useSettingSelector(
        SettingsType.DEFAULT,
        'audibleAlertMyWebcamWatcherJoined',
    )
    // `me.participants` does not exist until the first viewer joins
    // (worker builds it from an empty list on MYCAMSTATE), so absent === 0
    const participantCount = useRef(0)

    useEffect(() => {
        const count = participants?.length ?? 0
        const previousCount = participantCount.current
        participantCount.current = count

        // new viewer detected
        if (count > previousCount && audibleAlertMyWebcamWatcherJoined === 1) {
            playAudibleAlert(USER_EXTENSIONS.myWebCamNewViewerSound)
        }
    }, [participants, audibleAlertMyWebcamWatcherJoined])
}
